// src/features/roles/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import RolesPage from './pages/RolesPage';
import CreateRolePage from './pages/CreateRolePage';
import RoleDetailsPage from './pages/RoleDetailsPage';

export const RoleRoutes = () => (
  <Route path="roles">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="role:read">
          <RolesPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="role:create">
          <CreateRolePage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":roleId"
      element={
        <ProtectedRoute requiredScope="role:read">
          <RoleDetailsPage />
        </ProtectedRoute>
      }
    />
  </Route>
);